import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';
import {
	v4 as uuidv4
} from 'uuid';

const letterArr = ['a', 'b', 'c', 'd', 'e', 'f', 'g', 'h', 'i', 'j', 'k', 'l', 'm', 'n', 'o', 'p', 'q', 'r', 's', 't',
	'u', 'v', 'w', 'x', 'y', 'z', '0', '1', '2', '3', '4', '5', '6', '7', '8', '9'
];

/**
 * 生成key
 */
const generateKey = () => {
	let key = '';
	for (let i = 0; i < 32; i++) {
		const index = Math.floor(Math.random() * 36);
		key += letterArr[index];
	}
	return key;
};

const state = {
	// 用户信息
	user: null,
	// token
	token: null,
	userId: 0,
	localGuid: null,
	orderCard: null,
	orderCardInfo: null,
	cardSaleStatus: false
};

const mutations = {
	SET_TOKEN: (state, token) => {
		state.token = token;
		Cookies.set('ce_token', token);
	},
	DELETE_TOKEN: (state) => {
		state.token = null;
		Cookies.remove('ce_token');
	},
	SET_USER: (state, user) => {
		state.user = user;
		state.userId = user.Id;
		const key = generateKey();
		Cookies.set('ce_provider', key);
		const userStr = CryptoJS.AES.encrypt(JSON.stringify(user), key);
		Cookies.set('ce_user', userStr);
	},
	DELETE_USER: (state) => {
		state.user = null;
		state.localGuid = null;
		Cookies.remove('ce_user');
	},
	LOGOUT: (state) => {
		state.token = null;
		state.user = null;
		Cookies.remove('ce_token');
		Cookies.remove('ce_user');
		Cookies.remove('ce_provider');
		state.localGuid = null;
		Cookies.remove('ce_guid');
	},
	SET_LOCAL_GUID: (state, data) => {
		state.localGuid = data;
		Cookies.set('ce_guid', data);
	}
};

const actions = {
	/**
	 * 设置signalRProxy
	 *
	 * @param {*} {
	 *         commit
	 *     }
	 * @param {*} data
	 */
	setLocalGuid({
		commit
	}, data) {
		if (!data) {
			data = uuidv4();
		}
		commit('SET_LOCAL_GUID', data);
	},
	/**
	 * 获取token
	 *
	 * @param {*} {
	 *         commit,
	 *         state
	 *     }
	 * @param {*} data
	 */
	setToken({
		commit
	}, data) {
		commit('SET_TOKEN', data);
	},
	/**
	 * 删除token
	 *
	 * @param {*} {
	 *         commit
	 *     }
	 */
	deleteToken({
		commit
	}) {
		commit('DELETE_TOKEN');
	},
	/**
	 * 设置用户信息
	 *
	 * @param {*} { commit }
	 * @param {*} data
	 */
	setUser({
		commit
	}, data) {
		commit('SET_USER', data);
	},
	/**
	 * 删除用户
	 *
	 * @param {*} {
	 *         commit
	 *     }
	 */
	deleteUser({
		commit
	}) {
		commit('DELETE_USER');
	},
	/**
	 * 登出
	 *
	 * @param {*} {
	 *         commit
	 *     }
	 */
	logout({
		commit
	}) {
		commit('LOGOUT');
	}
};

export default {
	namespaced: true,
	state,
	mutations,
	actions
};
